import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { makeStyles } from '@material-ui/core/styles'

import { useStyles as useFormStyles } from '../styles'

const useStyles = makeStyles(theme => ({
  optionsColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%',
    paddingTop: theme.spacing(1),
  },
  optionLabel: {
    alignItems: 'flex-start',
    margin: 0,
    '& .MuiFormControlLabel-label': {
      marginTop: 2,
      marginLeft: theme.spacing(0.5),
      paddingTop: theme.spacing(0.25),
    },
  },
  optionTitle: {
    fontSize: '1rem',
    fontWeight: 400,
    color: theme.palette.text.primary,
    lineHeight: 1.25,
  },
  optionDescription: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
    marginTop: theme.spacing(1),
  },
  radio: {
    padding: theme.spacing(1),
    marginTop: -2,
    color: '#70787C',
    '&.Mui-checked': {
      color: '#0053FF',
    },
  },
}))

const VISIBILITY_OPTIONS = [
  {
    value: 'false',
    title: 'Listed',
    description: 'Discoverable in search on pga.com/things-to-do.',
  },
  {
    value: 'true',
    title: 'Unlisted',
    description: 'Hidden from search. Share your link to register.',
  },
]

const Unlisted = () => {
  const classes = useStyles()
  const formClasses = useFormStyles()
  const { control, watch } = useFormContext()
  const currentSetting = watch('unlisted')
  const selectedValue =
    currentSetting === true || currentSetting === 'true' ? 'true' : 'false'

  return (
    <Box className={formClasses.fieldGroup}>
      <Typography
        className={formClasses.sectionHeading}
        style={{ marginBottom: 12 }}
      >
        Visibility on PGA.com
      </Typography>
      <Controller
        name="unlisted"
        control={control}
        render={({ onChange }) => (
          <RadioGroup
            className={classes.optionsColumn}
            value={selectedValue}
            onChange={event => onChange(event.target.value)}
          >
            {VISIBILITY_OPTIONS.map(option => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                className={classes.optionLabel}
                control={<Radio className={classes.radio} color="primary" />}
                label={
                  <Box>
                    <Typography className={classes.optionTitle}>
                      {option.title}
                    </Typography>
                    <Typography className={classes.optionDescription}>
                      {option.description}
                    </Typography>
                  </Box>
                }
              />
            ))}
          </RadioGroup>
        )}
      />
    </Box>
  )
}

export default Unlisted
